import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from "./FileAppResource";
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import PhoneAppResource from "./PhoneAppResource";
import ServiceProviderRecommendationAppResource from "./ServiceProviderRecommendationAppResource";
import ServiceProviderContactLicenseTypeAppResource from "./ServiceProviderContactLicenseTypeAppResource";
import UserAppResource from "./UserAppResource";

export const SERVICE_PROVIDER_CONTACT = 'serviceProviderContact';

class ServiceProviderContactAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-contact';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/contacts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'firstName',
            'lastName',
            'email',
            'title',
            'website',
            'licenseTypeUuid',
            'licenseNumber',
            'avatarUuid',
            'description',
            'linkedinUrl',
            'facebookUrl',
            'serviceProviderUuid',
            'avatar',
            'serviceProvider',
            'phones',
            'recommendations',
            'licenseType',
            'isVisible',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            avatar: FileAppResource,
            serviceProvider: ServiceProviderAppResource,
            phones: PhoneAppResource,
            recommendations: ServiceProviderRecommendationAppResource,
            licenseType: ServiceProviderContactLicenseTypeAppResource,
            updatedByUser: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            avatar: 'avatar_uuid',
            serviceProvider: 'service_provider_uuid',
            licenseType: 'license_type_uuid',
            updatedByUser: 'updated_by_user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                email: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            website: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            licenseTypeUuid: {
                type: 'string',
            },
            licenseNumber: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            avatarUuid: {
                type: 'string',
            },
            linkedinUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            facebookUrl: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            serviceProviderUuid: {
                type: 'string',
                presence: true,
            },
            isVisible: {
                type: 'boolean',
            },
        };
    }
}

export default ServiceProviderContactAppResource;
